export function replaceCommaToDotFunction(value: string | number): string {
  if (!value && value !== 0) {
    return '';
  }
  return value.toString().replace(',', '.');
}
